'use client';

import { useFeatureIsOn as _useFeatureIsOn } from '@growthbook/growthbook-react';

import { AppFeatures } from '../types';

export const useFeatureIsOn = (id: keyof AppFeatures): boolean => _useFeatureIsOn<AppFeatures>(id);
